import { render, staticRenderFns } from "./SubsectionGroup.vue?vue&type=template&id=1a31eaeb&"
import script from "./SubsectionGroup.vue?vue&type=script&lang=js&"
export * from "./SubsectionGroup.vue?vue&type=script&lang=js&"
import style0 from "./SubsectionGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports